var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteerActivismHandHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.786 21.334q.262.07.607.06a1.7 1.7 0 0 0 .583-.108L22 18.65q0-.807-.571-1.354a1.87 1.87 0 0 0-1.334-.546h-6.524q-.071 0-.166-.012a.5.5 0 0 1-.143-.035l-1.405-.5a.43.43 0 0 1-.262-.237.55.55 0 0 1-.024-.356.43.43 0 0 1 .239-.261.46.46 0 0 1 .38-.024l1.072.404a.7.7 0 0 0 .155.06q.06.01.178.011h2.5q.453 0 .798-.309t.345-.807q0-.333-.202-.641a1.05 1.05 0 0 0-.536-.428l-6.595-2.446a5 5 0 0 0-.334-.083 1.6 1.6 0 0 0-.333-.036H7.714v8.574zM2 19.6q0 .783.56 1.342.559.558 1.345.558t1.345-.558q.56-.559.56-1.342v-6.65q0-.784-.56-1.342a1.84 1.84 0 0 0-1.345-.558q-.786 0-1.345.558Q2 12.167 2 12.95zm14.286-7.41a1.97 1.97 0 0 1-1.334-.522l-2.619-2.565a7.5 7.5 0 0 1-1.25-1.58 3.65 3.65 0 0 1-.512-1.888q0-1.306.917-2.22t2.226-.915q.762 0 1.429.32.666.32 1.143.868a3.5 3.5 0 0 1 1.143-.867q.666-.321 1.428-.321 1.31 0 2.226.914Q22 4.33 22 5.635q0 1.02-.5 1.888a7.2 7.2 0 0 1-1.238 1.58l-2.643 2.565a1.95 1.95 0 0 1-1.333.522"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerActivismHandHeart);
export default __webpack_public_path__ + "static/media/volunteer_activism_hand_heart.ed19cde222b88c2c976c1d0d89b02188.svg";
export { ForwardRef as ReactComponent };